import {connect} from 'react-redux';
// import {push} from 'connected-react-router'
import { useEffect, useState } from 'react';
import { 
    APPLICATION_MODE_RENEW, 
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT, 
    VIEW_MODE_REGULAR, 
    VIEW_MODE_RENEWAL_EDIT, 
    VIEW_MODE_RENEWAL_PREVIEW 
} from '../../app/constants';
import Navigation from '../Navigation';
import { companyTrademarkSelect } from '../../redux/selector/companyTrademarkSelector';
import TopNavigationBar from '../TopNavigationBar';
import { Button, ErrorMark, Header, NavigationLinkButton, Paragraph } from '../../components/RegularComponents';
import ReviewForm from '../../components/ReviewForm/ReviewForm';
import { setCompanyTrademark } from '../../redux/slice/primaryAgencyApplicationSlice';
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import { push } from 'connected-react-router';
import { replaceUrlParams } from '../../app/utils';
import { ERROR_STRING } from '../../app/errors';

const CompanyTrademark = (props) => {
    
    const {companyTrademark} = props
    
    const {applicationType,applicationMode} = props.match.params

    const [companyTrademarkText,setCompanyTrademarkText] = useState(companyTrademark.companyTrademark)
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    const [viewMode,setViewMode] = useState(props.viewMode ? 
        props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
            VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

    useEffect(() => {
        setCompanyTrademarkText(companyTrademark.companyTrademark)
    }, [companyTrademark])

    const onSaveAndNext = () => {

        props.dispatch(setCompanyTrademark(companyTrademarkText))
        setApplicationSaveError(false)

        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
        .then(data => {
            // move to the next screen
            props.dispatch(push(replaceUrlParams(companyTrademark.navigation.next, applicationType, applicationMode)))
        })
        .catch(error => {
            setApplicationSaveError(true)
        })
    }

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <TopNavigationBar {...props}/>
                    <div className="row bottomMarginNormal">
                        <div className="col-lg-8">
                            <Header 
                                id={'company-trademark-header'} 
                                header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? companyTrademark.headerRenewal : companyTrademark.header} />
                            <Paragraph 
                                id={'company-trademark-text'} 
                                text={viewMode === VIEW_MODE_RENEWAL_PREVIEW ? companyTrademark.textRenewal : companyTrademark.text} />
                        </div>
                    </div>
                </>
                }
                <div className="row bottomMarginMedium">
                    <div className="col-lg-8">
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                            <ReviewForm data={{
                                "Trademark name" : companyTrademarkText
                            }} />
                        }

                        {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                            <fieldset className="ns-fieldset">
                                <div className={"ns-fieldset"}>
                                    <label
                                        className="ns-label"
                                        htmlFor={'trademark-form-trademark-text'}
                                        id={"trademark-form-trademark-label"}>
                                            {"Trademark name"}
                                    </label>
                                    <input 
                                        id={"trademark-form-trademark-text"} 
                                        name={"trademark-form-trademark-text"} 
                                        className={"fw-20 ns-input"}
                                        type={"text"} 
                                        value={companyTrademarkText} 
                                        onInput={(e) => {
                                            setCompanyTrademarkText(e.target.value)
                                        }} 
                                        style={{width: "350px"}} />
                                </div>
                            </fieldset>
                        }
                    </div>
                </div>
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-4"}>
                            <Button 
                                id={"company-trademark-save-next"}
                                onClick={onSaveAndNext}
                                text={"Save and next"}
                                buttonType={"regular_primary"}
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && 
                            <div className="ns-error-message help-block topMarginNormal">
                                <span className="ns-visually-hidden">Error:</span>
                                {ERROR_STRING.APPLICATION_SAVE_ERROR}
                            </div>}
                        </div>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <div className="col-lg-4">
                            <NavigationLinkButton 
                                id={"company-trademark-edit-mode-switch"}
                                text={"Update this information before continuing"}
                                onClick={() => {
                                    setViewMode(VIEW_MODE_RENEWAL_EDIT)
                                }}
                            />
                        </div>}
                    </div>
                </>
                }
                {viewMode === VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <div className="row bottomMarginMedium">
                        <div className="col-lg-6">
                            <Button 
                                id={"company-trademark-edit-mode-save"}
                                onClick={() => {
                                    props.dispatch(setCompanyTrademark(companyTrademarkText))
                                    props.onEditSave()
                                }}
                                text={"Save"}
                                buttonType={"regular_primary"}
                            />
                        </div>
                    </div>
                </>
                }
            </div>
        </>
    )
}

export default connect(companyTrademarkSelect)(CompanyTrademark)